// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reverse[data-v-758f0d62],a[data-v-758f0d62]{unicode-bidi:bidi-override;direction:rtl}span[data-v-758f0d62]{display:none}", ""]);
// Exports
module.exports = exports;
